/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_Import_FilesInputs */

const en_dropbox_import_files = /** @type {(inputs: Dropbox_Import_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import files from Dropbox`)
};

const es_dropbox_import_files = /** @type {(inputs: Dropbox_Import_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa archivos de Dropbox`)
};

/**
* | output |
* | --- |
* | "Import files from Dropbox" |
*
* @param {Dropbox_Import_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_import_files = /** @type {((inputs?: Dropbox_Import_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_Import_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_import_files(inputs)
	return en_dropbox_import_files(inputs)
});